import { defineStore } from 'pinia'
import {IPopup} from "~/types/popup";

export const usePopup = defineStore('popup', {
  state: (): IPopup => {
    return {
      modalError: false,
      modalText: "",
      open: false
    }
  },
})